var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FF453A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 26.5C14.9233 26.5 12.8932 25.8842 11.1665 24.7304C9.4398 23.5767 8.09399 21.9368 7.29927 20.0182C6.50455 18.0996 6.29661 15.9884 6.70176 13.9516C7.1069 11.9148 8.10693 10.0438 9.57538 8.57538C11.0438 7.10693 12.9148 6.1069 14.9516 5.70176C16.9884 5.29661 19.0996 5.50455 21.0182 6.29927C22.9368 7.09399 24.5767 8.4398 25.7304 10.1665C26.8842 11.8932 27.5 13.9233 27.5 16C27.5 18.7848 26.3938 21.4555 24.4246 23.4246C22.4555 25.3938 19.7848 26.5 17 26.5ZM17 7C15.22 7 13.4799 7.52785 11.9999 8.51678C10.5198 9.50571 9.36628 10.9113 8.68509 12.5559C8.0039 14.2004 7.82567 16.01 8.17294 17.7558C8.5202 19.5016 9.37737 21.1053 10.636 22.364C11.8947 23.6226 13.4984 24.4798 15.2442 24.8271C16.99 25.1743 18.7996 24.9961 20.4442 24.3149C22.0887 23.6337 23.4943 22.4802 24.4832 21.0001C25.4722 19.5201 26 17.78 26 16C26 13.6131 25.0518 11.3239 23.364 9.63604C21.6761 7.94822 19.387 7 17 7Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4425 20.5L16.25 16.3075V9.25H17.75V15.685L21.5 19.4425L20.4425 20.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/offline.8478037e854baa6b8b50ed0b8ab5737a.svg";
export { ForwardRef as ReactComponent };